import { Injectable } from '@angular/core';
import { UserIdService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { ReturnAdapter } from './return.adapter';
import {
  ReturnRequestConfig,
  ReturnsRequestConfig,
  ReturnsStatusRequest, ReturnStatusRequest
} from "./return.model";

import {ExcelDownload} from "../../../../core/models/excelDownload.model";

@Injectable()
export class ReturnService {

  constructor(
    protected userIdService: UserIdService,
    private returnAdapter: ReturnAdapter,
  ) {}

  getReturns(returnsRequestConfig: ReturnsRequestConfig): Observable<ReturnsStatusRequest> {
    return this.returnAdapter.getReturns(returnsRequestConfig);
  }

  exportReturns(returnsRequestConfig: ReturnsRequestConfig): Observable<ExcelDownload> {
    return this.returnAdapter.getReturnsExport(returnsRequestConfig);
  }

  getOrder(returnRequestConfig: ReturnRequestConfig): Observable<ReturnStatusRequest> {
    return this.returnAdapter.getOrder(returnRequestConfig);
  }
  exportDetailsOrder(returnRequestConfig: ReturnRequestConfig): Observable<ExcelDownload> {
    return this.returnAdapter.exportDetailsOrder(returnRequestConfig);
  }

}
